import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    console.log("connected");
  }

  remove(event) {
    this.element.classList.add("hidden");
    this.inputTarget.value = "";
    const form = this.element.closest("form");
    form.requestSubmit();
  }
}